import { useState } from "react";
import deviceService from "../../../services/device/deviceService";
import log from "../../../services/logger/logger";

const useDeviceActions = (deviceId, onConnected, onDeviceUnselected, onReconnected) => {
    const [loading, setLoading] = useState(false);

    const handleDeviceConnection = async (action, callback = () => {}) => {
        setLoading(true);
        try {
            await action(deviceId);
            await callback(deviceId);
        } catch (error) {
            log.error(error);
        } finally {
            setLoading(false);
        }
    }

    const connect = () => handleDeviceConnection(deviceService.connect, onConnected)
    const disconnect = () => handleDeviceConnection(deviceService.disconnect, onDeviceUnselected)
    const reconnect = () => handleDeviceConnection(deviceService.reconnect, onReconnected)

    return { connect, disconnect, reconnect, loading };
};

export default useDeviceActions;